
export default class

  @getFirstRoundPrepareTime: -> 10

  @getRemainForSwitch: -> 1   # осталось меньше секунды - след состояние (чтобы не показывать "00:00")

  @getRemainForPlayPrepareSound: -> [ 4.5, 5.5 ]
